module.exports = __webpack_public_path__ + "img/your-subscription-is-about-expire-en.0e7abe6.png";